/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Wizard_Step4_Permission_ReadonlyInputs */



/**
* | output |
* | --- |
* | "Read Only" |
*
* @param {Spaces_Wizard_Step4_Permission_ReadonlyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_step4_permission_readonly = /** @type {((inputs?: Spaces_Wizard_Step4_Permission_ReadonlyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Step4_Permission_ReadonlyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur Lesen")
	return /** @type {LocalizedString} */ ("Read Only")
});